<template>
  <div class="map-controller">

    <visualization-button />

    <building-compass />

    <switch-pin-type />

    <visualization-color-chart />
  </div>
</template>

<script>
import visualizationButton from '../visualization/button.vue';
import switchPinType from './switch_pin_type.vue';
import visualizationColorChart from '../visualization/color_chart/frame.vue';
import buildingCompass from './building_compass.vue';

export default {
  components: {
    visualizationButton,
    switchPinType,
    visualizationColorChart,
    buildingCompass,
  },
};
</script>

<style scoped lang="scss">
.map-controller {
  position: absolute;
  top: 40px;
  right: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// controller.vue?53d76cd5